export const photoConfig = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  onProgress: function () {
    // Blank override
  },
}
